import type {
  Catalog,
  FetchCatalogListParams,
} from 'Services/ProductManagement/Features/Catalog/types'
import type { ListResponse } from 'Services/ProductManagement/types'
import { createBaseApi } from 'Util/ApiClient'

enum TagTypes {
  Catalog = 'Catalog',
}

export const catalogApi = createBaseApi({
  reducerPath: 'catalogApi',
  keepUnusedDataFor: 5,
  tagTypes: [TagTypes.Catalog],
}).injectEndpoints({
  endpoints: (builder) => ({
    getCatalogs: builder.query<
      ListResponse<Catalog>,
      FetchCatalogListParams | undefined
    >({
      query: (params) => ({
        url: '/api/v1/catalog/',
        params,
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.resources.map(({ id }) => ({
              type: TagTypes.Catalog,
              id,
            })),
            { type: TagTypes.Catalog, id: 'LIST' },
          ]
        }
        return [{ type: TagTypes.Catalog, id: 'LIST' }]
      },
    }),
    getSingleCatalog: builder.query<Catalog, string>({
      query: (id) => `/api/v1/catalog/${id}/`,
      providesTags: (_result, _error, id) => [{ type: TagTypes.Catalog, id }],
    }),
    createSingleCatalog: builder.mutation<Catalog, Partial<Catalog>>({
      query: (data) => ({
        url: `/api/v1/catalog/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: TagTypes.Catalog, id: 'LIST' }],
    }),
    updateSingleCatalog: builder.mutation<
      Catalog,
      { id: string } & Partial<Catalog>
    >({
      query: (data) => ({
        url: `/api/v1/catalog/${data.id}/`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: TagTypes.Catalog, id },
      ],
    }),
    deleteSingleCatalog: builder.mutation<Record<string, never>, string>({
      query: (id) => ({
        url: `/api/v1/catalog/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: TagTypes.Catalog, id: 'LIST' }],
    }),
  }),
})

export const {
  useGetCatalogsQuery,
  useGetSingleCatalogQuery,
  useCreateSingleCatalogMutation,
  useUpdateSingleCatalogMutation,
  useDeleteSingleCatalogMutation,
} = catalogApi
